import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { NextCoachingService } from '../../../coaching-base/coaching.service';
import { ObservationEntity } from '../../../coaching-base/config';
import { CoachingTranscript, LookupBox } from '../../../coaching-base/general';
import { TranscriptService as CoachingTranscriptService } from '../../../coaching-base/transcript.service';
import { ObservationService } from '../../../coaching-observation/observation/observation.service';
import { Dependencies } from '../../../store';
import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';

import { Reload, reloadResult } from './reload.action';

export const reloadEpic = (
    action: ActionsObservable<PayloadAction<ActionType, Reload>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<ActionType> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TD__RELOAD),
        switchMap((act: PayloadAction<ActionType, Reload>) => {
            const coachingService =
                deps.injector.get<NextCoachingService>(NextCoachingService);
            const observationService =
                deps.injector.get<ObservationService>(ObservationService);
            const ctsService = deps.injector.get<CoachingTranscriptService>(
                CoachingTranscriptService,
            );

            return forkJoin([
                of(null).pipe(coachingService.retrieveLookupBox()),
                of(null).pipe(observationService.retrieveObservationConfig()),
                ctsService.retrieve(
                    act.payload.platform,
                    act.payload.transcriptId,
                ),
            ]).pipe(
                map(
                    (
                        ret: [LookupBox, ObservationEntity, CoachingTranscript],
                    ) => {
                        return reloadResult(
                            {
                                ...act.payload,
                                behaviours: ret[0].behaviours,
                                subBehaviours: ret[0].subBehaviours,
                                observationConfig: ret[1],
                                transcript: ret[2],
                            },
                            act.storePath,
                        );
                    },
                ),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
